import { theme } from '@features/executive-report/domain/theme';
import { TextProps } from '@features/powerpoint';

export const overallPerformanceText: TextProps = {
  text: 'Overall Performance',
  options: {
    fontSize: 24,
    color: theme.colors.white,
    bold: true,
    h: 0.91,
    w: 3.1,
    x: 0.94,
    y: 2.36,
  },
};

export const recommendationText = (text: string): TextProps => ({
  text,
  options: {
    fontSize: 14,
    color: theme.colors.inmarketGreen,
    charSpacing: theme.charSpacing.veryLoose,
    bold: true,
    h: 0.34,
    w: 11.83,
    x: 0.76,
    y: 1.31,
  },
});

export const blueDimensionBoxText = (
  dimensionName: string,
  count: number
): TextProps => ({
  text: [
    {
      text: `Top ${count} `.toUpperCase(),
      options: {
        color: theme.colors.lightGray,
      },
    },
    {
      text: `${dimensionName}s`.toUpperCase(),
      options: {
        color: theme.colors.white,
        bold: true,
      },
    },
  ],
  options: {
    fontSize: 16,
    h: 0.37,
    w: 8.36,
    x: 4.34,
    y: 2.19,
    align: 'center',
  },
});
